// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteCustomerAddressMutation(
    $input: DeleteCustomerAddressInput!
  ) {
    deleteCustomerAddress(input: $input) {
      deletedId
      customer {
        id
        ...CustomerSidePanel_customer
        ...AddUpdateCustomerModal_customer
        ...AddUpdateOrderModal_customer
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
